import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-square-price',
    templateUrl: './square-price.component.html',
    styleUrls: ['./square-price.component.scss']
})
export class SquarePriceComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }
}
